import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import RenderProductState from 'Components/Utility/Product/RenderProductState';
import useFetchProduct from 'Hooks/useFetchProduct';
import SmallUspBar from 'Components/Usp/SmallUspBar';
import SelectedTierContext from 'Features/Bundle/context/selected-tier-context';
import BundleView from 'Features/Bundle/components/Layout/BundleView';
import MysteryBundleView from 'Features/Bundle/components/Layout/MysteryBundleView';
import VisibleVoucher from 'Components/Vouchers/VisibleVoucher';

const ProductView = lazy(() => import(/* webpackChunkName: "ProductView" */ 'Features/Product/components/Views/ProductView'));

const BundlePage = ({ match = {}, isPreview }) => {
  const slug = match?.params?.slug;
  const id = match?.params?.id;
  const type = 'bundle';
  const cartItems = useSelector(state => state.cart.items);
  const [selectedTier, selectTier] = useState(-1);
  const [inCartTier, setInCartTier] = useState(-1);

  const {
    product,
    urlRedirect,
    redirect,
    notFound,
    isLoading,
  } = useFetchProduct({ slug, id, type, isPreview });

  useEffect(() => {
    if (product?.bundles?.length > 1) {
      const tierToSelect = product.bundles.length - 1;

      if (product?._id && cartItems?.length) {
        const itemInCart = cartItems.find(i => i.pid === product._id);
        if (itemInCart && typeof itemInCart.tierIndex === 'number' && selectedTier !== itemInCart.tierIndex) {
          selectTier(itemInCart.tierIndex);
          setInCartTier(itemInCart.tierIndex);
        } else if (selectedTier < 0) {
          selectTier(tierToSelect);
        }
      } else if (selectedTier < 0 || selectedTier > tierToSelect) {
        selectTier(tierToSelect);
      }
    }
  }, [cartItems, product]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderState = RenderProductState({
    urlRedirect,
    matchUrl: match.url,
    redirect,
    notFound,
    isLoading,
    product,
  });

  if (renderState) return renderState;

  let componentToLoad = 'product';

  if (product?.type === 'bundle' && product?.template_type !== 'original') {
    componentToLoad = 'bundle';
  }

  if (product?.type === 'bundle' && product?.mystery) {
    componentToLoad = 'mystery';
  }

  return (
    <SelectedTierContext.Provider value={{ selectedTier, inCartTier, selectTier }}>
      <SmallUspBar product={product} />
      <VisibleVoucher product={product} />

      {(componentToLoad === 'product') &&
        <Suspense>
          <ProductView product={product} />
        </Suspense>
      }

      {componentToLoad === 'bundle' &&
        <BundleView product={product} />
      }

      {componentToLoad === 'mystery' &&
        <MysteryBundleView product={product} />
      }

    </SelectedTierContext.Provider>
  );
};

export default BundlePage;
